module.exports = __webpack_public_path__ + "static/media/profile-press-id@2x.c6503066.png";